const titleElement = document.querySelector(".financing-options-title");

if (titleElement) {
    const box = document.querySelector(".financing-options-box");
    const arrowBtn = document.querySelector(".financing-options-title svg");
    const accordion_active = document.querySelector(".accordion-active");

    if (accordion_active) {
        box.classList.add("open");
        arrowBtn.classList.add("open");
        box.style.maxHeight = box.scrollHeight + 500 + "px";
    }

    titleElement.addEventListener("click", function () {
        if (box.classList.contains("open")) {
            box.classList.remove("open");
            arrowBtn.classList.remove("open");
            box.style.maxHeight = null;
        } else {
            box.classList.add("open");
            arrowBtn.classList.add("open");
            box.style.maxHeight = box.scrollHeight + 100 + "px";
        }
    });
}

const dom = {
    querySelector: (selector, parent = document) => parent.querySelector(selector),
    querySelectorAll: (selector, parent = document) => parent.querySelectorAll(selector),
    createElement: (tag) => document.createElement(tag),
    addEventListener: (element, event, handler) => element?.addEventListener(event, handler),
};

const outputFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
});

const parsePrice = (priceString) => {
    if (!priceString) return 0;
    const price = Number(priceString.replace(/,/g, ""));
    return price >= 10000000 ? price / 100 : price;
};

if (document.querySelector(".financing-options")) {
    document.addEventListener("DOMContentLoaded", initializeApp);
}

function initializeApp() {
    moveFinanceMainOptions();
    initializeMainTab(document);
    initializeTab(document);
    initializeTabTexts(document);
    initializeFinanceOptionsPopup();
    initializeScroll(document);
    initializePriceObserver();
    readMoreListener();
}

function initializeMainTab(dom) {
    const mainTabBlocks = dom.querySelectorAll(".tabs-container-block");
    const tabTitles = dom.querySelectorAll(".tab--title");
    const tabDescriptions = dom.querySelectorAll(".tab--description");

    function updateTabsBasedOnActive() {
        const activeMainTab = dom.querySelector(".tabs-container-block.tabs-container-active");
        const activeIndex = [...mainTabBlocks].indexOf(activeMainTab);
        const activeClass = `finance-option-${activeIndex + 1}`;

        tabTitles.forEach(title => {
            title.style.display = title.classList.contains(activeClass) ? "block" : "none";
        });

        tabDescriptions.forEach(desc => {
            desc.style.display = desc.classList.contains(activeClass) ? "block" : "none";
        });

        dom.querySelectorAll('.tab--title').forEach(el => el.classList.remove('tab--active'));
        const firstVisibleTab = dom.querySelector(`.tab--title.${activeClass}`);
        if (firstVisibleTab) firstVisibleTab.classList.add('tab--active');

        const firstVisibleDesc = dom.querySelector(`.tab--description.${activeClass}`);
        tabDescriptions.forEach(desc => desc.style.display = "none");
        if (firstVisibleDesc) firstVisibleDesc.style.display = "block";
    }
    mainTabBlocks.forEach((mainTabBlock) => {
        mainTabBlock.addEventListener("click", () => {
            mainTabBlocks.forEach(block => block.classList.remove("tabs-container-active"));
            mainTabBlock.classList.add("tabs-container-active");

            updateTabsBasedOnActive();
        });
    });

    updateTabsBasedOnActive();
}

function initializePriceObserver() {
    const optionsContainer = document.querySelector(".options_description-container");
    if (!optionsContainer) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "data-product-actual-price") {
                const tabTexts = document.querySelectorAll(".tab-text");
                const { symbol: currencySymbol = "$", code: currencyCode = "US" } = optionsContainer.dataset;
                const newPrice = optionsContainer.dataset.productActualPrice;
                tabTexts.forEach((tabText) => {
                    recalculateInstallments(tabText, currencySymbol, currencyCode, newPrice);
                });
            }
        });
    });

    observer.observe(optionsContainer, { attributes: true });
}

function recalculateInstallments(tabText, currencySymbol, currencyCode, newPrice) {
    const select = tabText.querySelector("select");
    const selectedDisplay = tabText.querySelector(".selected-option-display");
    const descriptionWrapper = tabText.querySelector(".description-wrapper");
    const finalPriceBlock = tabText.querySelector(".final-price-block");
    const container = document.querySelector(".options_description-container");

    if (!select || !selectedDisplay || !descriptionWrapper || !finalPriceBlock) return;

    const formattedProductPrice = container?.dataset?.productPrice || "$0 COP";

    const totalPrice = parsePrice(newPrice);

    const tempDiv = createTempDiv(tabText.getAttribute("data-description"));
    updateProductPrice(tempDiv, formattedProductPrice);

    const installementsData = tabText.getAttribute("data-installments") || "1";

    if (installementsData) {
        const installmentsNumbers = JSON.parse(installementsData);

        Array.from(select.options).forEach((option, index) => {
            const installmentMonth = installmentsNumbers[index];
            const installmentMonthNumber = Number(installmentMonth);
            const installmentPriceNumber = outputFormatter.format(totalPrice / installmentMonthNumber);
            option.textContent = `desde ${currencySymbol}${installmentPriceNumber} ${currencyCode} en ${installmentMonth} pagos`;
        });

        const selectedIndex = select.value;
        const selectedMonth = installmentsNumbers[selectedIndex];
        const selectedMonthNumber = Number(selectedMonth);
        const selectedPriceNumber = outputFormatter.format(totalPrice / selectedMonthNumber);

        updateInstallmentInfo(
            selectedDisplay,
            descriptionWrapper,
            tempDiv,
            selectedPriceNumber,
            selectedMonthNumber,
            selectedMonth,
            currencySymbol,
            currencyCode,
            finalPriceBlock,
        );
    }
}

function moveFinanceMainOptions() {
    const financingOptionsBox = dom.querySelector(".financing-options-main");
    const financeMainOptions = dom.querySelector(".finance-main-options");
    if (financingOptionsBox && financeMainOptions) {
        financingOptionsBox.appendChild(financeMainOptions);
    }
}

function initializeTab(container) {
    const tabTitles = dom.querySelectorAll(".tab-header .tab--title", container);
    const promotionBlocks = dom.querySelectorAll(".tab-block", container);

    tabTitles.forEach((tabTitle, index) => {
        dom.addEventListener(tabTitle, "click", (event) => handleTabClick(event, tabTitle, index, container, promotionBlocks));
    });
}

function handleTabClick(event, tabTitle, index, container, promotionBlocks) {
    const parentElement = tabTitle.parentElement;
    if (parentElement && parentElement.tagName === "A" && parentElement.href && parentElement.href.includes("#")) {
        event.preventDefault();
    }

    const activeElement = dom.querySelector(".tab-header .tab--title.tab--active", container);
    if (activeElement) {
        activeElement.classList.remove("tab--active");
    }

    tabTitle.classList.add("tab--active");
    promotionBlocks.forEach((block, i) => {
        block.style.display = i === index ? "block" : "none";
    });
}

function initializeTabTexts(container) {
    const tabTexts = dom.querySelectorAll(".tab-text", container);
    const optionsDescriptionContainer = dom.querySelector(".options_description-container", container);
    if (tabTexts.length === 0 || !optionsDescriptionContainer) return;

    const straightCashPriceText = dom.querySelector(".straight-discount-price")?.textContent;
    const {
        symbol: currencySymbol = "$",
        code: currencyCode = "COP",
        productPrice: productActualPrice = "0",
    } = optionsDescriptionContainer.dataset;

    tabTexts.forEach((tabText) => processTabText(tabText, currencySymbol, currencyCode, straightCashPriceText || productActualPrice));
}

function processTabText(tabText, currencySymbol, currencyCode, productActualPrice) {
    const descriptionData = tabText.getAttribute("data-description");
    const paymentUrl = tabText.getAttribute("data-url");
    const paymentText = tabText.getAttribute("data-url-text");
    const productPrice = tabText.getAttribute("data-product-payment-price");
    const tempDiv = createTempDiv(descriptionData);
    updateProductPrice(tempDiv, productActualPrice);

    const installementsData = tabText.getAttribute("data-installments") || JSON.stringify(["1"]);
    if (installementsData && installementsData.length > 0) {
        const installmentsNumbers = JSON.parse(installementsData);
        const { selectWrapper, descriptionWrapper, finalPriceBlock } = createInstallmentElements(
            installmentsNumbers,
            tempDiv,
            currencySymbol,
            currencyCode,
        );

        tabText.innerHTML = "";
        tabText.appendChild(selectWrapper);

        const financeOptionsTitle = tabText.nextElementSibling;
        if (financeOptionsTitle && financeOptionsTitle.classList.contains("popupmain-title")) {
            tabText.appendChild(financeOptionsTitle);
        }

        if (paymentUrl && paymentText) {
            const paymentUrlWrapper = document.createElement("a");
            paymentUrlWrapper.classList.add("description-wrapper-url");
            paymentUrlWrapper.href = paymentUrl + productPrice + "&theme=";
            paymentUrlWrapper.target = "_blank";
            paymentUrlWrapper.textContent = paymentText;
            descriptionWrapper.appendChild(paymentUrlWrapper);
        }

        tabText.appendChild(descriptionWrapper);
        tabText.appendChild(finalPriceBlock);
    }
}

function createTempDiv(html) {
    const tempDiv = dom.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv;
}

function updateProductPrice(tempDiv, price) {
    const productPriceElement = dom.querySelector(".product-price", tempDiv);
    if (productPriceElement) {
        productPriceElement.textContent = price;
    }
}

function createInstallmentElements(installmentsNumbers, tempDiv, currencySymbol, currencyCode) {
    const select = dom.createElement("select");
    const selectWrapper = dom.createElement("div");
    selectWrapper.classList.add("custom-select");
    const descriptionWrapper = dom.createElement("div");
    descriptionWrapper.classList.add("description-wrapper");

    const selectedDisplay = dom.createElement("span");
    selectedDisplay.classList.add("selected-option-display");
    selectWrapper.appendChild(selectedDisplay);

    const finalPriceBlock = createFinalPriceBlock();

    const currentPrice = document.querySelector(".options_description-container")?.dataset?.productActualPrice || "0";
    const totalPrice = parsePrice(currentPrice);

    installmentsNumbers.forEach((installmentMonth, index) => {
        const installmentMonthNumber = Number(installmentMonth);
        const installmentPriceNumber = outputFormatter.format(totalPrice / installmentMonthNumber);

        const option = createOption(installmentPriceNumber, installmentMonth, index, currencySymbol, currencyCode);
        select.appendChild(option);

        if (index === 0) {
            updateInstallmentInfo(
                selectedDisplay,
                descriptionWrapper,
                tempDiv,
                installmentPriceNumber,
                installmentMonthNumber,
                installmentMonth,
                currencySymbol,
                currencyCode,
                finalPriceBlock,
            );
        }
    });

    selectWrapper.appendChild(select);
    dom.addEventListener(select, "change", (event) =>
        handleSelectChange(
            event,
            installmentsNumbers,
            totalPrice,
            selectedDisplay,
            descriptionWrapper,
            tempDiv,
            currencySymbol,
            currencyCode,
            finalPriceBlock,
        ),
    );

    return { selectWrapper, descriptionWrapper, finalPriceBlock };
}

function handleSelectChange(
    event,
    installmentsNumbers,
    _totalPrice,
    selectedDisplay,
    descriptionWrapper,
    tempDiv,
    currencySymbol,
    currencyCode,
    finalPriceBlock,
) {
    const container = document.querySelector(".options_description-container");

    const formattedProductPrice = container?.dataset?.productPrice || "$0 COP";

    const actualPrice = container?.dataset?.productActualPrice || "0";
    const totalPrice = parsePrice(actualPrice);

    updateProductPrice(tempDiv, formattedProductPrice);

    const selectedIndex = event.target.value;
    const selectedMonth = installmentsNumbers[selectedIndex];
    const selectedMonthNumber = Number(selectedMonth);
    const selectedPriceNumber = outputFormatter.format(totalPrice / selectedMonthNumber);

    updateInstallmentInfo(
        selectedDisplay,
        descriptionWrapper,
        tempDiv,
        selectedPriceNumber,
        selectedMonthNumber,
        selectedMonth,
        currencySymbol,
        currencyCode,
        finalPriceBlock,
    );
}

function createFinalPriceBlock() {
    const finalPriceBlock = dom.createElement("div");
    finalPriceBlock.classList.add("final-price-block");
    finalPriceBlock.innerHTML = `
        <h5>Precio Final</h5>
        <div class="final-price-info">
            <span class="installment-price"></span>/mes.
            Por <span class="installment-month"></span> meses.
        </div>
    `;
    return finalPriceBlock;
}

function updateInstallmentInfo(
    selectedDisplay,
    descriptionWrapper,
    tempDiv,
    price,
    monthNumber,
    monthText,
    currencySymbol,
    currencyCode,
    finalPriceBlock,
) {
    selectedDisplay.textContent = `desde ${currencySymbol}${price} ${currencyCode} en ${monthText} pagos`;

    descriptionWrapper.innerHTML = tempDiv.innerHTML;

    const installmentMonthContent = dom.querySelector(".installment-month", descriptionWrapper);
    const installmentPriceContent = dom.querySelector(".installment-price", descriptionWrapper);

    if (installmentMonthContent) {
        installmentMonthContent.textContent = monthText;
    }
    if (installmentPriceContent) {
        installmentPriceContent.textContent = `${currencySymbol}${price} ${currencyCode}`;
    }

    updateFinalPriceBlock(finalPriceBlock, monthText, currencySymbol, price, currencyCode);
}

function updateFinalPriceBlock(finalPriceBlock, monthText, currencySymbol, price, currencyCode) {
    const finalPriceMonthContent = dom.querySelectorAll(".installment-month", finalPriceBlock);
    finalPriceMonthContent.forEach((element) => {
        element.textContent = monthText;
    });

    const finalPriceInstallmentContent = dom.querySelector(".installment-price", finalPriceBlock);
    if (finalPriceInstallmentContent) {
        finalPriceInstallmentContent.textContent = `${currencySymbol}${price} ${currencyCode}`;
    }
}

function createOption(price, month, index, currencySymbol, currencyCode) {
    const option = dom.createElement("option");
    option.value = index;
    option.textContent = `desde ${currencySymbol}${price} ${currencyCode} en ${month} pagos`;
    return option;
}

function initializeScroll(container) {
    const scrollContainer = container.querySelector(".options-scroll-container");
    if (!scrollContainer) return;

    const leftButton = container.querySelector(".options-slide-left");
    const rightButton = container.querySelector(".options-slide-right");

    let isDown = false;
    let startX;
    let scrollLeft;

    scrollContainer.style.scrollBehavior = "smooth";

    const events = {
        mousedown: (e) => {
            isDown = true;
            scrollContainer.style.cursor = "grabbing";
            scrollContainer.style.scrollBehavior = "auto";
            startX = e.pageX - scrollContainer.offsetLeft;
            scrollLeft = scrollContainer.scrollLeft;
        },
        mouseleave: () => {
            isDown = false;
            scrollContainer.style.cursor = "grab";
            scrollContainer.style.scrollBehavior = "smooth";
        },
        mouseup: () => {
            isDown = false;
            scrollContainer.style.cursor = "grab";
            scrollContainer.style.scrollBehavior = "smooth";
        },
        mousemove: (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 2;
            scrollContainer.scrollLeft = scrollLeft - walk;
            updateButtonStates();
        },
        touchstart: (e) => {
            scrollContainer.style.scrollBehavior = "auto";
            startX = e.touches[0].pageX - scrollContainer.offsetLeft;
            scrollLeft = scrollContainer.scrollLeft;
        },
        touchend: () => {
            scrollContainer.style.scrollBehavior = "smooth";
        },
        touchmove: (e) => {
            if (e.touches.length !== 1) return;
            const x = e.touches[0].pageX - scrollContainer.offsetLeft;
            const walk = (x - startX) * 2;
            scrollContainer.scrollLeft = scrollLeft - walk;
            e.preventDefault();
            updateButtonStates();
        },
    };

    Object.entries(events).forEach(([event, handler]) => {
        scrollContainer.addEventListener(event, handler, { passive: false });
    });

    const scrollAmount = 200;

    leftButton.addEventListener("click", () => {
        scrollContainer.scrollBy({
            left: -scrollAmount,
            behavior: "smooth",
        });
        updateButtonStates();
    });

    rightButton.addEventListener("click", () => {
        scrollContainer.scrollBy({
            left: scrollAmount,
            behavior: "smooth",
        });
        updateButtonStates();
    });

    function updateButtonStates() {
        const scrollLeft = scrollContainer.scrollLeft;
        const scrollWidth = scrollContainer.scrollWidth;
        const clientWidth = scrollContainer.clientWidth;

        if (scrollLeft <= 0) {
            leftButton.setAttribute("disabled", "disabled");
            leftButton.classList.add("disabled");
        } else {
            leftButton.removeAttribute("disabled");
            leftButton.classList.remove("disabled");
        }

        if (scrollLeft + clientWidth >= scrollWidth) {
            rightButton.setAttribute("disabled", "disabled");
            rightButton.classList.add("disabled");
        } else {
            rightButton.removeAttribute("disabled");
            rightButton.classList.remove("disabled");
        }
    }

    updateButtonStates();

    scrollContainer.addEventListener("scroll", updateButtonStates);
}

function initializeFinanceOptionsPopup() {
    const financeOptionsPopupButton = dom.querySelector(".financing-options-button");
    const financeOptionsPopupOverlay = dom.querySelector(".finance-options-modal-overlay");
    const financingOptionsMain = dom.querySelector(".financing-options-main");
    const popUpContent = dom.querySelector(".finance-options-modal-content");
    const closeButton = dom.querySelector(".finance-modal-close");

    if (!financeOptionsPopupButton || !financeOptionsPopupOverlay || !financingOptionsMain || !popUpContent || !closeButton) {
        console.warn("Finance options popup elements not found");
        return;
    }

    dom.addEventListener(financeOptionsPopupButton, "click", openModal);
    dom.addEventListener(financeOptionsPopupOverlay, "click", handleOverlayClick);
    dom.addEventListener(document, "keydown", handleEscapeKey);
    closeButton.addEventListener("click", closeModal);

    function openModal() {
        const headerClone = financingOptionsMain.cloneNode(true);
        const popUpmainBlockTitle = financingOptionsMain.querySelectorAll(".popupmain-title");

        popUpContent.innerHTML = "";
        popUpContent.appendChild(headerClone);

        const popupTabTexts = headerClone.querySelectorAll(".tab-text");
        const optionsDescriptionContainer = headerClone.querySelector(".options_description-container");

        if (optionsDescriptionContainer) {
            const {
                symbol: currencySymbol = "$",
                code: currencyCode = "COP",
                productPrice: productActualPrice = "0",
            } = optionsDescriptionContainer.dataset;

            popupTabTexts.forEach((tabText, index) => {
                processTabText(tabText, currencySymbol, currencyCode, productActualPrice);
                const customSelect = tabText.querySelector(".custom-select");
                if (popUpmainBlockTitle[index] && customSelect) {
                    const logoClone = popUpmainBlockTitle[index].cloneNode(true);
                    customSelect.insertAdjacentElement("afterend", logoClone);
                }
            });
        }

        financeOptionsPopupOverlay.classList.add("modal-open");
        document.body.style.overflow = "hidden";
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = "fixed";

        initializeMainTab(headerClone);
        initializeTab(headerClone);
        initializeScroll(headerClone);
    }

    function handleOverlayClick(event) {
        if (event.target === financeOptionsPopupOverlay) {
            closeModal();
        }
    }

    function handleEscapeKey(event) {
        if (event.key === "Escape" && financeOptionsPopupOverlay.classList.contains("modal-open")) {
            closeModal();
        }
    }

    function closeModal() {
        financeOptionsPopupOverlay.classList.remove("modal-open");
        const scrollY = document.body.style.top;
        document.body.style.overflow = "";
        document.body.style.top = "";
        document.body.style.position = "";
        window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
}

function createPopupInfoDiv(popUpInfo) {
    const popupInfoDiv = dom.createElement("div");
    popupInfoDiv.classList.add("popupinfo-main");
    const popupInfoWrapper = dom.createElement("div");
    popupInfoWrapper.classList.add("popupinfo-info-wrapper");

    popupInfoWrapper.innerHTML = popUpInfo;
    popupInfoDiv.appendChild(popupInfoWrapper);
    return popupInfoDiv;
}
function readMoreListener() {
    const readMoreButtons = document.querySelectorAll(".popupmain-read-more");
    const descriptionWrappers = document.querySelectorAll(".description-wrapper");

    readMoreButtons.forEach((button, index) => {
        if (!descriptionWrappers[index]) {
            button.classList.add("hide-block");
            button.previousElementSibling.classList.add("hide-block");
        }
        if (descriptionWrappers[index] && button) {
            button.addEventListener("click", () => {
                descriptionWrappers[index].classList.add("open");
                button.classList.add("hide-block");
                button.previousElementSibling.classList.add("hide-block");
            });
        }
    });
}

function updateZeroPercentFinancePrice() {
    const priceElement = document.querySelector(".js-product-price-with-care-warranty");
    const optionsContainer = document.querySelector(".options_description-container");

    const actualPriceWithoutCurrency = priceElement?.dataset?.priceWithoutCurrency;
    const actualPriceWithCurrency = priceElement?.dataset?.price;

    if (actualPriceWithoutCurrency && optionsContainer) {
        optionsContainer.dataset.productActualPrice = actualPriceWithoutCurrency;
        optionsContainer.dataset.productPrice = actualPriceWithCurrency;
    }
}

$(document).on("change", ".product-form__input:not(.product-form__input--trade-in) input[type=radio]", function () {
    setTimeout(() => {
        updateZeroPercentFinancePrice();
    }, 2000);
});
